import {
  convertZonetoUTCEnd,
  convertZonetoUTCStart,
} from "../Helper/DatePicker/DateConverter";
import { prepareHeadersForGlobalFilters } from "../PagesContent/Overview/CommonFunctions";
import { GetData } from "./Functions/SettingData";
import { getBmsFaultErrorCodesHeader } from "./Functions/BmsFaultHeader";
import qs from "qs";

async function getDigitalTwinList(data, additionalHeaders = {}, module = null) {
  const filters = data?.filters || {};

  const normalizedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      acc[key] = value.map((item) => {
        if (typeof item === "string") {
          try {
            return JSON.parse(item);
          } catch {
            return item;
          }
        }
        return item;
      });
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
  let rawJson = {
    ...data,
    ...filters,
    startDate: convertZonetoUTCStart(data?.startDate),
    endDate: convertZonetoUTCEnd(data?.endDate),
    pageCount: data.rowsPerPage,
    sortBy: data?.sortBy ? data?.sortBy : 'addedOn',
    order: data?.orderBy ? data?.orderBy : 'desc',
    filters: Object.keys(filters).length ? JSON.stringify(normalizedFilters) : undefined,
  };

  // Add partial connectivity filter parameters if provided
  if (data?.canDataTypes && Array.isArray(data.canDataTypes)) {
    rawJson.canDataTypes = data.canDataTypes;
  }

  if (data?.canDataDateRange) {
    rawJson.canDataDateRange = JSON.stringify(data.canDataDateRange);
  }

  let headers = {
    "Content-Type": "application/json",
    ...getBmsFaultErrorCodesHeader(),
  };

  if (Object.keys(additionalHeaders).length || module) {
    headers = { ...prepareHeadersForGlobalFilters(additionalHeaders, module), ...getBmsFaultErrorCodesHeader() };
  }

  var config = {
    method: "get",
    url: `/api/digital_twin_list/${data.pageNumber}`,
    headers,
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let response = GetData(config, true);
  return response;
}

async function getDigitalTwinData(data, additionalHeaders = {}) {
  let headers = { "Content-Type": "application/json" };
  if (Object.keys(additionalHeaders).length) {
    headers = prepareHeadersForGlobalFilters(additionalHeaders);
  }

  // Normalize filters: date calendar filters store values as [jsonString] (array).
  // Parse each JSON string so the backend receives parsed objects, not raw strings.
  const rawFilters = data?.filters;
  const normalizedFilters = rawFilters && typeof rawFilters === "object" && !Array.isArray(rawFilters)
    ? Object.entries(rawFilters).reduce((acc, [key, value]) => {
        if (Array.isArray(value)) {
          acc[key] = value.map((item) => {
            if (typeof item === "string") {
              try { return JSON.parse(item); } catch { return item; }
            }
            return item;
          });
        } else {
          acc[key] = value;
        }
        return acc;
      }, {})
    : rawFilters;

  var config = {
    method: "post",
    url: `/api/digital_twin/actions`,
    headers,
    data: normalizedFilters !== rawFilters ? { ...data, filters: normalizedFilters } : data,
  };

  let response = GetData(config, true);

  return response;
}


async function getDigitalTwinConfigList(data) {
  let rawJson = {
    ...data,
    ...data.filters,
    pageCount: data?.rowsPerPage ? data?.rowsPerPage : 20,
    sortBy: data?.sortBy ? data?.sortBy : 'id',
    order: data?.orderBy ? data?.orderBy : 'desc',
  };
  var config = {
    method: "get",
    url: `/api/battery_config_list/${data.pageNumber ? data.pageNumber : 1}`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let response = GetData(config, true);
  return response;
}

async function addDigitalTwin(data) {
  let json = data;
  var config = {
    method: "post",
    url: `/api/digital_twin_list`,
    headers: {
      "Content-Type": "application/json",
    },
    data: json,
  };
  let response = GetData(config, true);
  return response;
}

async function updateDigitalTwin(data) {
  let json = data;
  var config = {
    method: "put",
    url: `/api/digital_twin_list/${data?.id}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: json,
  };
  let response = GetData(config, true);
  return response;
}

async function addConfig(data) {
  let json = data;
  var config = {
    method: "post",
    url: `/api/battery_config_list`,
    headers: {
      "Content-Type": "application/json",
    },
    data: json,
  };
  let response = GetData(config, true);
  return response;
}

async function updateConfig(data) {
  let json = data;
  var config = {
    method: "put",
    url: `/api/battery_config_list/${data?.id}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: json,
  };
  let response = GetData(config, true);
  return response;
}

async function getConfigList() {
  var config = {
    method: "get",
    url: `/api/battery_config_form_dropdown`,
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      filters: ["configName", "fleetName"],
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let response = GetData(config, true);
  return response;
}

async function getConfigFilterValues() {
  var config = {
    method: "get",
    url: `/api/battery_config_form_dropdown`,
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      // filters: ["packOEM", "iotOEM", "bmsOEM"],
      filters: [
        "fleetName",
        "buildingBlockType",
        "applicationOEM",
        "iotOEM",
        "bmsOEM",
        "packOEM",
        "cellOEM",
        "cellModelNumber",
        "cellChemistry",
        "formFactorCell",
        "configName",
      ],
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let response = GetData(config, true);
  return response;
}

async function getDigitalTwinListSearch(search, limit) {
  let newColumnName = "deviceID";

  var rawJson = {
    columnName: newColumnName,
    columnSearch: search,
    columnLimit: limit,
  };
  var config = {
    method: "get",
    url: `/api/digital_twin_list_search`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
}


async function genericSearchSuggestions(search, columnName = "deviceID", limit = 5) {

  var rawJson = {
    columnName: columnName,
    columnSearch: search,
    columnLimit: limit,
  };
  var config = {
    method: "get",
    url: `/api/generic_search_suggestions`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
}

async function addOrganization(data) {
  let json = data;
  var config = {
    method: "post",
    url: `/api/new_fleet`,
    headers: {
      "Content-Type": "application/json",
    },
    data: json,
  };
  let response = GetData(config, true);
  return response;
}


async function getDigitalTwinConfigAlerts(params) {
  let rawJson = {
    ...params,
  };
  var config = {
    method: "get",
    url: `/api/alert/config_alerts`,
    headers: {
      "Content-Type": "application/json",
    },
    params: rawJson,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let response = GetData(config, true);
  return response;
}


async function updateDigitalTwinConfigAlerts(data) {
  let json = data;
  var config = {
    method: "post",
    url: `/api/alert/update_config_alerts`,
    headers: {
      "Content-Type": "application/json",
    },
    data: json,
  };
  let response = GetData(config, true);
  return response;
}

export {
  getDigitalTwinList,
  getDigitalTwinData,
  getDigitalTwinConfigList,
  addDigitalTwin,
  updateDigitalTwin,
  addConfig,
  updateConfig,
  getConfigList,
  getConfigFilterValues,
  getDigitalTwinListSearch,
  addOrganization,
  getDigitalTwinConfigAlerts,
  updateDigitalTwinConfigAlerts,
  genericSearchSuggestions
};
